import { render } from "./BuscaCadastro.vue?vue&type=template&id=cd963484&ts=true"
import script from "./BuscaCadastro.vue?vue&type=script&lang=ts"
export * from "./BuscaCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__